import { memo } from "react";

import { Pressable } from "@/components/atoms/Pressable";
import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";

/**
 * Watchlist data structure
 */
interface Watchlist {
  id: string;
  name: string;
  lastModified?: string;
}

/**
 * Props for WatchlistItemView component
 */
interface WatchlistItemViewProps {
  readonly watchlist: Watchlist;
  readonly isSelected: boolean;
  readonly onPress: () => void;
}

/**
 * WatchlistItemView - View Component
 * Pure UI component for a single watchlist item in the dropdown menu.
 * @param root0 - The component props
 * @param root0.watchlist - The watchlist data to display
 * @param root0.isSelected - Whether this watchlist is currently selected
 * @param root0.onPress - Callback when the item is pressed
 */
const WatchlistItemView = ({
  watchlist,
  isSelected,
  onPress,
}: WatchlistItemViewProps) => (
  <Pressable
    onPress={onPress}
    className={`rounded-none px-3 py-2 ${
      isSelected ? "bg-surface-subtle" : "bg-transparent"
    }`}
  >
    <Stack direction="horizontal" className="items-center justify-between">
      <Text variant="body-strong" className="text-content-primary">
        {watchlist.name}
      </Text>
    </Stack>
  </Pressable>
);

WatchlistItemView.displayName = "WatchlistItemView";

export default memo(WatchlistItemView);
export type { WatchlistItemViewProps, Watchlist };
